import { Route } from '/@/modules/core/app/constants/api.constants';
import { BaseFormService } from '/@/modules/core/form/services/BaseFormService';
import { TimeEntry } from '/@/modules/timeentry/models/TimeEntry';
import { BaseModelType } from '@/modules/core/app/models/abstracts/BaseModel';

export class TimeEntryFormService extends BaseFormService {
  getRoute(): Route {
    return Route.TIMEENTRIES;
  }

  getModel(): BaseModelType<TimeEntry> {
    return TimeEntry;
  }
}

export default new TimeEntryFormService();
